import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { MessageSquareHeart, MapPin } from 'lucide-react';
const messages = [{
  id: 1,
  name: 'Lewis K.',
  city: 'Abu Dhabi, UAE 🇦🇪',
  text: 'From the desert to the safari — 40 looks unstoppable on you. Honored to ride this wave with you.',
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=150&auto=format&fit=crop'
}, {
  id: 2,
  name: 'Clodagh B.',
  city: 'London, UK 🇬🇧',
  text: "Amoye! 40 looks incredible on you. Can't wait to celebrate in Bali!",
  image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=150&auto=format&fit=crop'
}, {
  id: 3,
  name: 'Ace B.',
  city: 'Atlanta, GA 🇺🇸',
  text: 'Amoye is exactly who you think she is, and somehow you still underestimated her.',
  image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=150&auto=format&fit=crop'
}, {
  id: 4,
  name: 'Courtney R.',
  city: 'Toronto, ON 🇨🇦',
  text: 'Cheers to 60 countries and counting. You inspire us all to live louder and travel further.',
  image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?q=80&w=150&auto=format&fit=crop'
}, {
  id: 5,
  name: 'Nada S.',
  city: 'Cairo, Egypt 🇪🇬',
  text: 'From the pyramids to the savannah — wishing you a 40th as legendary as your journey. Habibti! ✨',
  image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=150&auto=format&fit=crop'
}, {
  id: 6,
  name: 'Solomon O.',
  city: 'Accra, Ghana 🇬🇭',
  text: 'Akwaaba sister! 40 is just the beginning of your most powerful chapter. See you in Botswana.',
  image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?q=80&w=150&auto=format&fit=crop'
}, {
  id: 7,
  name: 'Cecily C.',
  city: 'Shanghai, China 🇨🇳',
  text: 'Wishing you boundless joy and new horizons on this incredible milestone. See you on the journey!',
  image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=150&auto=format&fit=crop'
}, {
  id: 8,
  name: 'Jose M.',
  city: 'San Jose, Costa Rica 🇨🇷',
  text: 'Pura vida, Amoye! May this next era be filled with as much vibrant energy as you bring to the world.',
  image: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?q=80&w=150&auto=format&fit=crop'
}, {
  id: 9,
  name: 'Richard E.',
  city: 'Rome, Italy 🇮🇹',
  text: 'Auguri! Celebrating your beautiful life and the adventures ahead. Ciao bella, see you soon!',
  image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?q=80&w=150&auto=format&fit=crop'
}];
export function GuestWall() {
  return <section className="py-32 bg-rich-black relative overflow-hidden" data-id="element-169">
      {/* Background Map Graphic Placeholder */}
      <div className="absolute inset-0 opacity-5 pointer-events-none bg-[url('https://upload.wikimedia.org/wikipedia/commons/8/80/World_map_-_low_resolution.svg')] bg-no-repeat bg-center bg-cover" data-id="element-170" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-171">
        <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-6" data-id="element-172">
          <div className="max-w-2xl" data-id="element-173">
            <h2 className="font-display text-4xl md:text-5xl font-bold mb-4" data-id="element-174">
              Global <span className="text-gradient-ocean" data-id="element-175">Guest Wall</span>
            </h2>
            <p className="font-sans text-lg text-gray-400" data-id="element-176">
              Friends from around the world sharing love, memories, and
              excitement for the journey ahead.
            </p>
          </div>
          <button className="glass-panel px-6 py-3 rounded-full font-sans font-medium text-white hover:bg-white/10 transition-colors flex items-center gap-2 whitespace-nowrap" data-id="element-177">
            <MessageSquareHeart size={20} data-id="element-178" /> Leave a Message
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-179">
          {messages.map((msg, index) => <motion.div key={msg.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="glass-panel-hover glass-panel p-6 rounded-2xl transition-all duration-300" data-id="element-180">
              <div className="flex items-center gap-4 mb-4" data-id="element-181">
                <img src={msg.image} alt={msg.name} className="w-12 h-12 rounded-full object-cover border border-gold/30" data-id="element-182" />
                <div data-id="element-183">
                  <h4 className="font-sans font-bold text-white" data-id="element-184">{msg.name}</h4>
                  <p className="font-sans text-xs text-gold flex items-center gap-1" data-id="element-185">
                    <MapPin size={12} data-id="element-186" /> {msg.city}
                  </p>
                </div>
              </div>
              <p className="font-sans text-gray-300 text-sm leading-relaxed" data-id="element-187">
                "{msg.text}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}